import ActivityReason from './ActivityReason'
import SwapReason from './SwapReason'
import EquipmentCategory from './EquipmentCategory'
export class CustomerRequirementInfo {
    RequestID: number;
    HoursCustomerIsAvailable: string;
    CustomerAvailabilityStart: Date;
    CustomerAvailabilityEnd: Date;
    CustomerAvailabilityStartString: string;
    CustomerAvailabilityEndString: string;
    RequestedInstallDate: Date;
    RequestedRemoveDate: Date;
    RequestedSwapDate: Date;
    RequestedMoveDate: Date;
    RequestedSurveyDate: Date;
    RequestedMaintenanceDate: Date;
    StairClimber: boolean;
    SpecialClearance: boolean;
    SpecialEventInstallDate: Date;
    ActivityReasonID?: number;
    ActivityReason?: ActivityReason;
    RemoveCoolerReasonID?: number;
    RemoveFountainReasonID?: number;
    RemoveVendorReasonID?: number;
    SwapReasonID?: number;
    SwapReason?: SwapReason;
    SpecialEventRemovalDate: Date;
    LineFlushOrFireUp?: boolean;
    BIBRackRelocation?: boolean;
    CO2Relocation?: boolean;
    EquipmentAssetNumber?: string;
    SerialNumber?: string;
    ModelNumber?: string;
    EquipmentCategoryID?: number;
    EquipmentCategory?: EquipmentCategory;
    SpecialEvent?: boolean;
    FlavorChange: boolean;
}

export default CustomerRequirementInfo;